import { Row, Col } from 'antd';
import { useEffect, useState } from 'react';

import img_bg_desktop from '../assets/img_event_20250519_banner_desktop.png';
import img_bg_mobile from '../assets/img_event_20250519_banner_mobile.png';

const Header = () => {
    const [contentOpacity, setContentOpacity] = useState(0);
    
    useEffect(() => {
        setTimeout(() => setContentOpacity(1), 500);
    }, []);
    return (
        <div style={{ position: 'relative' }}>
            <Row>
                <Col lg={24} md={0} sm={0} xs={0} style={{ position: 'relative', textAlign: 'center' }}>
                    <img src={img_bg_desktop} alt='img_bg_desktop' style={{ width: '90vw', position: 'relative', maxWidth: '1200px', padding: '20px 0px 32px' }}/>
                    <div style={{ position: 'absolute', left: '120px', top: '160px', opacity: contentOpacity, transition: 'opacity 1s' }}>
                    </div>
                </Col>
                <Col lg={0} md={24} sm={24} xs={24} style={{ backgroundColor: '#ECF4FD' }}>
                    <img src={img_bg_mobile} alt='img_bg_mobile' style={{ width: '100vw', position: 'relative', paddingTop: '20px' }}/>
                    <div style={{marginTop: '24px', textAlign: 'center', opacity: contentOpacity, transition: 'opacity 1s' }}>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Header;
